var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.template.name
        ? [
            _vm.template.locked || _vm.preview
              ? _c("div", { staticClass: "questionnaireEditGroupHeader" }, [
                  _c(
                    "span",
                    { staticClass: "questionnaireEditGroupHeaderText" },
                    [_vm._v(_vm._s(_vm.template.name))]
                  ),
                ])
              : _c("div", { staticClass: "questionnaireEditGroupHeader" }, [
                  _c("label", { staticClass: "rbCheckbox" }, [
                    _c("input", {
                      staticClass: "rbCheckboxInput",
                      attrs: {
                        id: _vm.template.id,
                        type: "checkbox",
                        name: _vm.template.id,
                      },
                      domProps: { value: _vm.isSelected },
                      on: {
                        change: function ($event) {
                          return _vm.onChange($event.target.value)
                        },
                      },
                    }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "rbCheckboxLabel questionnaireEditGroupHeaderText",
                        class: _vm.isSelected,
                      },
                      [_vm._v(" " + _vm._s(_vm.template.name) + " ")]
                    ),
                  ]),
                ]),
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "questionnaireEditGroupQuestions" },
        _vm._l(_vm.template.cells, function (cell) {
          return _c("questionnaire-edit-question", {
            key: cell.id,
            attrs: {
              model: _vm.getModel(cell.id),
              preview: _vm.preview,
              template: cell,
            },
            on: {
              questionAdded: _vm.addSectionAndForwardEvent,
              questionRemoved: _vm.addSectionAndForwardEvent,
              questionRequiredChanged: _vm.addSectionAndForwardEvent,
              userDefinedChanged: _vm.addSectionAndForwardEvent,
              userDefinedRemoved: _vm.addSectionAndForwardEvent,
            },
          })
        }),
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }